import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const messages = {
  en: {
    message: {
      PreRegister: "Visitor Pre-registration",
      TerminalStamp: "Terminal Stamp",
      ParkingRedemption: "Parking Redemption",
      ManagePreRegister: "Manage Pre Register",
      Redemption: "Redemption",
      Search: "Search",
      ScanQRCode: "Scan QRCode",
      PleaseInput: "Please Input",
      InputPlaceholder: "License No./Ticket No./Log Id.",
      ParkingInformation: "Parking Information",
      TicketNo: "Ticket No.",
      DateTime: "Date",
      DateTimeIn: "DateTimeIn",
      TimeIn: "Time In",
      Duration: "Duration",
      exempt: "Exempt",
      summaryDuration: "Summary Duration",
      CarLicense: "License Plate",
      VehicleName: "Vehicle Name",
      RateCode: "RateCode",
      RateDetail: "Rate Detail",
      Total: "Total",
      SpendingValue: "Spending Value",
      POSValue: "POS Value",
      Scanner: "Scanner",
      ClearRate: "Clear Rate Detail",
      Remark: "Remark",
      EStamp: "E-Stamp",
      Cancel: "Cancel",
      RedemptionSuccess: "Redemption Success !",
      Back: "Back",
      Submit: "Submit",
      TotalAmount: "Total",
      Add: "Add",
      Create: "Create",
      CreateInvite: "Create Invite",
      Baht: "Baht",
      CouponValue: "Coupon",
      Hour: "Hour",
      TotalCoupon: "Total Coupon",
      POSValueOrCoupon: "POS/Coupon",
      UsageTiger: "Usage Tiger Retail Shop",
      UsageCoupon: "Rabbit Rewards Coupon",
      NormalServiceRate: "Rate Detail",
      PromotionDiscount: "Promotion Discount",
      ReceiptFromPurchase: "Receipt From Purchase",
      TotalPromotionDiscount: "Total Promotion Discount",
      RateDetailLang: "ENG",
      Close: "Close",
      VehicleType: "VehicleType",
      Next: "Next",
      Car: "Car",
      Motorcycle: "Motorcycle",
      No: "No.",
      StartDate: "Start Date",
      EndDate: "End Date",
      StartTime: "Start Time",
      EndTime: "End Time",
      PreRegisterParking: "Pre Register",
      WalkIn: "Walk In",
      MyQR: "My QR",
      PreRegisterParkingMenu: "Parking Pre Register",
      WorkPermitNumber: "Work Permit No",
      FirstName: "First Name",
      LastName: "Last Name",
      PhoneNumber: "Phone",
      Email: "Email",
      VisitorEmail: "Visitor Email",
      LicensePlate: "License Plate",
      Province: "Province",
      VisitorSummary: "Visitor Summary",
      FullName: "Name",
      OfficerApprove: "Officer Approve",
      SelectApproverEmail: "Select Approver Email",
      ParkingWalkIn: "Parking Walk In",
      GetThaiID: "Get Thai ID",
      GetPassport: "Get Passport",
      PreRegisterDetail: "Pre Register Detail",
      CreateTime: "Create Time",
      Approved: "Approved",
      NotApproved: "Not Approved",
      Active: "Active",
      InActive: "In Active",
      Status: "Status",
      Action: "Action",
      VisitorType: "Visitor Type",
      StatusApprove: "Approve",
      WalkInName: "Walk In",
      JorporPlus: "JorporPlus",
      SelfPreRegister: "Self PreRegister",
      Expired: "Expired",
      Rejected: "Rejected",
      UserManagement: "User Management",
      Username: "Username",
      RoleName: "Rolename",
      ManageUser: "Manage User",
      Password: "Password",
      Role: "Role",
      SectionName: "Section",
      Update: "Update",
      ManageRole: "Manage Role",
      RoleID: "Role ID",
      Permission: "Permission",
      ManageSection: "Manage Section",
      BlackListVisitor: "BlackList Visitor",
      SectionNameTH: "SectionName",
      SectionNameENG: "SectionName ENG",
      SectionID: "SectionID",
      Approver: "Approver",
      Subordinates: "Subordinates (Users)",
      Users: "Users",
      ChangePassword: "Change Password",
      OldPassword: "Old Password",
      NewPassword: "New Password",
      ConfirmNewPassword: "Confirm Password",
      ChangePasswordRequired: "Please complete all password fields.",
      ChangePasswordMismatch: "New Password and Confirm Password must match.",
      ChangePasswordUpdated: "Password updated",
      ChangePasswordSuccess: "Password updated successfully.",
      ChangePasswordFailed: "Unable to change password.",
      Logout: "Logout",
      BlackList: "BlackList Visitor",
      BlacklistID: "Blacklist ID",
      InviteTenantName: "Invite Tenant Name",
      InviteLocationName: "Invite Location Name",
      GuestInviteName: "Guest Invite Name",
      InvitationName: "Invitation Name",
      VisitorName: "Visitor Name",
      ViewPreRegister: "View Pre Register",
      GuestInformation: "Guest Information",
      InviteNo: "Invite No",
      InviteName: "Invite Name",
      Location: "Location",
      Tenant: "Tenant",
      VisitDuration: "Visit Duration",
      WantToReject: "Do you want to reject this pre-register ?",
      Reject: "Reject",
      Information: "Information",
      RedemptionHistory: "Redemption History",
      BackToMain: "Back to main",
      SelectFloor: "Select Floor",
      SyncMemberFineday: "Sync Member Fineday",
      MemberID: "Member ID",
      Telephone: "Telephone",
      RedemptionSettings: "Redemption Settings",
      Department: "Department",
      RedemptionType: "Redemption Type",
      UserLevel: "User Level",
      UpdateTime: "Update Time",
      ParkingLot: "Parking Lot",
      InvitationEmail: "Invitation Email",
      SelectTenant: "Select Tenant",
      InvitationUser: "Invitation User",
      Name: "Name",
      TenantName: "TenantName",
      TenantNameTH : "TenantNameTH",
      ManageTenant: "Manage Tenant",
    },
    transactionRoomBooking: {
      filters: "Transaction filters",
      startTime: "Start Time",
      expireTime: "Expire Time",
      status: "Status",
      search: "Search",
      searchTransaction: "Search transaction",
      export: "Export",
      swipeHint: "Swipe left or right to view all columns",
      no: "No.",
      bookingName: "Booking Name",
      hostName: "Host Name",
      facility: "Facility",
      checkIn: "Check-In",
      checkOut: "Check-Out",
      action: "Action",
      active: "Active",
      inactive: "Inactive",
      checkedIn: "Checked in",
      notCheckedIn: "Not checked in",
      checkedOut: "Checked out",
      notCheckedOut: "Not checked out",
      editTransaction: "Edit transaction",
      deleteTransaction: "Delete transaction",
      closeEditTransaction: "Close edit transaction",
      transactionStatus: "Transaction status",
      noData: "No transaction data found",
      cancel: "Cancel",
      save: "Save",
      loading: "Loading, please wait...",
      connectionError: "Unable to connect to the system.",
      loadFailed: "Unable to load transactions.",
      facilityLoadFailed: "Unable to load facilities.",
      exportFailed: "Unable to export transactions.",
      error: "Error...",
      invalidDateRange: "Expire Time must be the same as or later than Start Time.",
      invalidTransactionId: "Invalid transaction ID.",
      updated: "Updated",
      updateSuccess: "Successfully updated.",
      updateFailed: "Unable to update transaction.",
      bookingNameRequired: "Please enter Booking Name.",
      hostNameRequired: "Please enter Host Name.",
      facilityRequired: "Please select Facility.",
      startTimeRequired: "Please select Start Time.",
      expireTimeRequired: "Please select Expire Time.",
      invalidDateTime: "Invalid Start Time or Expire Time.",
      expireAfterStart: "Expire Time must be later than Start Time.",
      deleteConfirmTitle: "Delete transaction?",
      deleteConfirmText: "Are you sure you want to delete {name}?",
      thisTransaction: "this transaction",
      delete: "Delete",
      deleted: "Deleted",
      deleteSuccess: "Transaction deleted successfully.",
      deleteFailed: "Unable to delete transaction.",
    },
    facilityPage: {
      title: "Facility",
      updatedAt: "Last updated",
      actions: "Actions",
      search: "Search",
      searchFacility: "Search facility",
      create: "Create",
      detail: "Detail",
      noUtilities: "No utilities available",
      delete: "Delete",
      edit: "Edit",
      noFacilities: "No facilities found",
      createFacility: "Create Facility",
      editFacility: "Edit Facility Information",
      close: "Close",
      facilityName: "Facility Name",
      roomType: "Room Type",
      eventType: "Event Type",
      location: "Zone",
      floor: "Floor",
      startTime: "Start Time",
      endTime: "End Time",
      room: "Room",
      space: "Space",
      reserve: "Reserve",
      facilityPreview: "Facility preview",
      changeImage: "Change facility image",
      facilityStatus: "Facility status",
      active: "Active",
      inactive: "Inactive",
      no: "No.",
      utilityName: "Utility Name",
      amount: "Amount",
      deleteUtility: "Delete utility",
      noUtilityData: "No utility data found",
      cancel: "Cancel",
      save: "Save",
      loading: "Loading, please wait...",
      error: "Error...",
      utilityLoadFailed: "Unable to load utility data.",
      locationLoadFailed: "Unable to load zone data.",
      floorLoadFailed: "Unable to load floor data.",
      loadFailed: "Unable to load facility data.",
      invalidImage: "Only PNG, JPG, or BMP files up to 5 MB are supported.",
      imageReadFailed: "Unable to read the image file.",
      invalidImageFile: "Invalid image file.",
      facilityNameRequired: "Please enter Facility Name.",
      roomTypeRequired: "Please select Room Type.",
      eventTypeRequired: "Please select Event Type.",
      locationRequired: "Please select Zone.",
      floorRequired: "Please select Floor.",
      startTimeRequired: "Please select Start Time.",
      endTimeRequired: "Please select End Time.",
      invalidTime: "Start Time or End Time is invalid.",
      endAfterStart: "End Time must be later than Start Time.",
      saveFailed: "Unable to save Facility.",
      created: "Created",
      updated: "Updated",
      createSuccess: "Successfully created.",
      updateSuccess: "Successfully updated.",
      deleteConfirmTitle: "Delete Facility?",
      deleteConfirmText: "Are you sure you want to delete this Facility?",
      deleteFailed: "Unable to delete Facility.",
      deleted: "Deleted",
      deleteSuccess: "Successfully deleted.",
    },
    infrastructure: {
      search: "Search",
      status: "Status",
      action: "Action",
      actions: "Actions",
      create: "Create",
      update: "Update",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      close: "Close",
      active: "Active",
      inactive: "Inactive",
      loading: "Loading, please wait...",
      connectionError: "Unable to connect to the system.",
      created: "Created",
      updated: "Updated",
      deleted: "Deleted",
      createSuccess: "Successfully created.",
      updateSuccess: "Successfully updated.",
      deleteSuccess: "Successfully deleted.",
      editNamed: "Edit {name}",
      deleteNamed: "Delete {name}",
      zone: "zone",
      utility: "utility",
      location: "location",
      zoneFilters: "Zone filters",
      searchZone: "Search zone",
      zoneName: "Zone Name",
      zoneNameTH: "Zone Name TH",
      zoneStatus: "Zone status",
      noZoneData: "No zone data found",
      editZone: "Edit Zone",
      createZone: "Create Zone",
      closeZoneDialog: "Close zone dialog",
      zoneNameRequired: "Please enter Zone Name.",
      zoneNameTHRequired: "Please enter Zone Name TH.",
      zoneNameTooLong: "Zone Name must not exceed 200 characters.",
      zoneNameTHTooLong: "Zone Name TH must not exceed 200 characters.",
      deleteZoneTitle: "Delete Zone?",
      deleteZoneText: "Are you sure you want to delete this Zone?",
      searchUtility: "Search utility",
      utilityName: "Utility Name",
      utilityNameTH: "Utility Name TH",
      noUtilityData: "No utility data found",
      editUtility: "Edit Utility",
      createUtility: "Create Utility",
      utilityNameRequired: "Please enter Utility Name.",
      utilityNameTHRequired: "Please enter Utility Name TH.",
      utilityNameTooLong: "Utility Name must not exceed 200 characters.",
      utilityNameTHTooLong: "Utility Name TH must not exceed 200 characters.",
      deleteUtilityTitle: "Delete Utility?",
      deleteUtilityText: "Are you sure you want to delete this Utility?",
      locationFilters: "Location filters",
      searchLocation: "Search location",
      locationName: "Location Name",
      locationNameTH: "Location Name TH",
      locationStatus: "Location status",
      noLocationData: "No location data found",
      editLocation: "Edit Location",
      createLocation: "Create Location",
      closeLocationDialog: "Close location dialog",
      locationNameRequired: "Please enter Location Name.",
      locationNameTHRequired: "Please enter Location Name TH.",
      locationNameTooLong: "Location Name must not exceed 200 characters.",
      locationNameTHTooLong: "Location Name TH must not exceed 200 characters.",
      deleteLocationTitle: "Delete Location?",
      deleteLocationText: "Are you sure you want to delete this Location?",
    },
    management: {
      search: "Search", create: "Create", update: "Update", cancel: "Cancel",
      active: "Active", inactive: "Inactive", loading: "Loading, please wait...",
      confirm: "Confirm", confirmInactive: "Confirm inactive?", error: "Error",
      connectionError: "Unable to connect to the system.", saveFailed: "Save failed.", updateFailed: "Update failed.",
      created: "Created", updated: "Updated", createSuccess: "Successfully created.", updateSuccess: "Successfully updated.",
      statusRequired: "Status is required.", editNamed: "Edit {name}", deleteNamed: "Delete {name}",
      roomPadActions: "Room Pad actions", searchRoomPad: "Search Room Pad", roomPad: "Room Pad",
      padName: "Pad Name", facility: "Facility", noRoomPadData: "No Room Pad data found",
      editRoomPad: "Edit Room Pad", createRoomPad: "Create Room Pad", deleteRoomPad: "Delete Room Pad",
      closeRoomPadDialog: "Close Room Pad dialog", generalInformation: "General information", name: "Name",
      calendarType: "Calendar Type", systemConnection: "System connection", calendarSyncHint: "Used for syncing calendars.",
      tenantId: "Tenant ID", clientId: "Client ID", clientSecret: "Client Secret", userEmail: "User Email",
      googleCalendarId: "Google Calendar ID", roomPadStatus: "Room Pad status",
      roomPadNameRequired: "Room Pad Name is required.", facilityRequired: "Facility is required.",
      calendarTypeRequired: "Calendar Type is required.", tenantIdRequired: "Tenant ID is required.",
      clientIdRequired: "Client ID is required.", clientSecretRequired: "Client Secret is required.",
      userEmailRequired: "User Email is required.", googleCalendarIdRequired: "Google Calendar ID is required.",
      roomPadInactiveText: "This Room Pad will become inactive.",
      userActions: "User actions", searchUser: "Search user", user: "user", noUserData: "No user data found",
      editUser: "Edit User", createUser: "Create User", closeUserDialog: "Close user dialog",
      profileImage: "Profile image", chooseProfileImage: "Choose profile image", profilePreview: "Profile preview",
      removeImage: "Remove image", firstName: "First name", lastName: "Last name", userName: "User name",
      password: "Password", passwordEditHint: "Leave blank to keep current password", email: "Email", roleName: "Role name",
      userStatus: "User status", userInactiveText: "This User will become inactive.",
      usernameRequired: "Username is required.", passwordRequired: "Password is required.",
      passwordMinLength: "Password must contain at least 8 characters.", firstNameRequired: "First Name is required.",
      lastNameRequired: "Last Name is required.", invalidEmail: "Email format is invalid.",
      roleRequired: "Role is required.", roomPadRequired: "Room Pad is required.",
      shiftStartTime: "Shift start", shiftEndTime: "Shift end", location: "Location", serviceArea: "Service Area",
      shiftHoursRequired: "Enter both shift times in HH:mm format.", shiftHoursDifferent: "Shift start and end times must differ.",
      locationRequired: "Location is required.", serviceAreaRequired: "Select a Service Area for this Location.",
      invalidProfileImage: "Profile image must be a JPEG, PNG, or WebP image.",
      profileImageTooLarge: "Profile image must not exceed 2 MB.", profileImageReadFailed: "Unable to read profile image.",
      roleTools: "Role tools", searchRole: "Search role", noRoleData: "No role data found",
      editRole: "Edit Role", createRole: "Create Role", deleteRole: "Delete Role",
      closeRoleDialog: "Close role dialog", roleStatus: "Role status", permissionNamed: "Permission {id}",
      roleNameRequired: "Role Name is required.", roleInactiveText: "This Role and its Permissions will become inactive.",
    },
    manageOrder: {
      title: "Manage Order", order: "Order", orderTime: "Order Time", completedTime: "Completed Time",
      status: "Status", search: "Search", export: "Export", no: "No.", orderId: "Order ID",
      requester: "Requester", location: "Location", zone: "Zone", staff: "Staff", action: "Action",
      new: "New", preparing: "Preparing", ready: "Ready", completed: "Completed", rejected: "Rejected",
      details: "View order {id}", back: "Back to orders", information: "Order Information",
      items: "Order Items", itemDescription: "Item Description & Specifications", quantity: "Quantity",
      itemSummary: "{count} Distinct Items • Total {quantity} Units", meeting: "Meeting",
      service: "Service", serviceArea: "Service Area", unassigned: "Unassigned",
      cancelOrder: "Cancel Order", cancelReason: "Cancellation reason", cancelHint: "Enter a reason (maximum 500 characters).",
      confirmCancel: "Confirm cancellation", close: "Close", cancellationReason: "Cancellation reason",
      empty: "No orders found", loading: "Loading orders…", retry: "Try again",
      loadError: "Unable to load orders.", detailError: "Unable to load order details.",
      accessError: "Your role does not have permission to manage orders.",
      cancelError: "Unable to cancel the order.", conflict: "This order has changed. The latest details have been reloaded. Please review before trying again.",
      exportError: "Unable to export orders.", rowsPerPage: "Rows per page", filters: "Order filters",
      unknown: "Unknown", clearDate: "Clear date", units: "Units", exportItems: "Items",
    },
    dashboard: {
      title: "Workspace Overview", updatedAt: "Last updated", refresh: "Refresh", logout: "Logout",
      transaction: "Transaction", facility: "Facility", zone: "Zone", utility: "Utility", location: "Location", roomPad: "Room Pad", manageUser: "Manage User", manageRole: "Manage Role",
      allRoom: "All rooms", meetingNow: "Meeting now", available: "Available", bookingToday: "Bookings today", pendingOrder: "Pending orders",
      floorMap: "Floor map", selectFloor: "Select floor", allFloors: "All floors", nextMeeting: "Next meeting", noNextMeeting: "No upcoming meeting", viewSchedule: "View schedule",
      activity: "Activity", latestOrder: "Latest orders", noRooms: "No rooms found on this floor", noActivity: "No recent activity", noOrders: "No recent orders",
      loadError: "Dashboard data could not be loaded.", retry: "Try again", loading: "Loading dashboard", sent: "Sent", new: "New",
      booking: "New booking", checkin: "Checked in", checkout: "Checked out", updated: "Booking updated", hostedBy: "Hosted by",
    },
  },
  th: {
    message: {
      PreRegister: "ลงทะเบียนผู้มาติดต่อล่วงหน้า",
      TerminalStamp: "จุดบริการทำส่วนลดค่าจอดรถ",
      ParkingRedemption: "ส่วนลดค่าบริการที่จอดรถ",
      Redemption: "ประทับตราส่วนลดค่าจอดรถ",
      ManagePreRegister: "จัดการผู้มาติดต่อล่วงหน้า",
      Search: "ค้นหา",
      ScanQRCode: "สแกนคิวอาร์โค้ด",
      PleaseInput: "กรุณากรอก",
      InputPlaceholder: "ทะเบียนรถ/เลขบัตรจอดรถ/รหัสรายการ",
      ParkingInformation: "รายละเอียดการจอดรถ",
      TicketNo: "เลขบัตรจอดรถ",
      DateTime: "วันที่",
      DateTimeIn: "วันที่เข้า",
      TimeIn: "เวลาเข้า",
      Duration: "ระยะเวลาจอดรถ",
      exempt: "ได้รับยกเว้น",
      summaryDuration: "เวลาสุทธิ",
      CarLicense: "ทะเบียนรถ",
      VehicleName: "ประเภทยานพาหนะ",
      RateCode: "รหัสตราประทับ",
      RateDetail: "รายละเอียดเงื่อนไข",
      Total: "ค่าจอดรถ",
      SpendingValue: "ยอดค่าใช้จ่าย",
      POSValue: "ยอดใบเสร็จ POS",
      Scanner: "เครื่องสแกน",
      ClearRate: "เคลียร์เงื่อนไข",
      Remark: "หมายเหตุ",
      EStamp: "ประทับตรา",
      Redeem: "ไถ่ถอน",
      Cancel: "ยกเลิก",
      RedemptionSuccess: "ประทับตราส่วนลดสำเร็จ",
      Back: "ย้อนกลับ",
      Submit: "ตกลง",
      TotalAmount: "รวมทั้งสิ้น",
      Add: "เพิ่มข้อมูล",
      Create: "เพิ่มข้อมูล",
      Baht: "บาท",
      CouponValue: "ยอดคูปอง",
      Hour: "ชั่วโมง",
      TotalCoupon: "รวมคูปอง",
      POSValueOrCoupon: "ยอดใบเสร็จ POS/คูปอง",
      UsageTiger: "ใช้บริการร้านค้า Tiger",
      UsageCoupon: "คูปอง Rabbit Rewards",
      NormalServiceRate: "อัตราค่าบริการปกติ",
      PromotionDiscount: "ส่วนลดจากโปรโมชัน",
      ReceiptFromPurchase: "ใบเสร็จจากการซื้อสินค้า",
      TotalPromotionDiscount: "รวมส่วนลดโปรโมชัน",
      RateDetailLang: "TH",
      Close: "ปิด",
      VehicleType: "กรุณาเลือกประเภทรถ",
      Next: "ต่อไป",
      Car: "รถยนต์",
      Motorcycle: "รถจักรยานยนต์",
      No: "ลำดับที่",
      StartDate: "วันที่เริ่มต้น",
      EndDate: "วันที่สิ้นสุด",
      StartTime: "เวลาเริ่มต้น",
      EndTime: "เวลาสิ้นสุด",
      PreRegisterParking: "ลงทะเบียนจอดรถล่วงหน้า",
      WalkIn: "ลงทะเบียนผู้มาติดต่อ",
      MyQR: "คิวอาร์โค้ดของฉัน",
      PreRegisterParkingMenu: "ลงทะเบียนจอดรถล่วงหน้า",
      WorkPermitNumber: "หมายเลขใบอนุญาตทำงาน",
      FirstName: "ชื่อ",
      LastName: "นามสกุล",
      PhoneNumber: "เบอร์โทรศัพท์",
      Email: "อีเมล",
      VisitorEmail: "อีเมลล์ผู้มาติดต่อ",
      LicensePlate: "หมายเลขทะเบียนรถ",
      Province: "จังหวัด",
      VisitorSummary: "สรุปข้อมูลผู้มาติดต่อ",
      FullName: "ชื่อ-นามสกุล",
      OfficerApprove: "เจ้าหน้าที่อนุมัติ",
      SelectApproverEmail: "เลือกอีเมลผู้อนุมัติ",
      ParkingWalkIn: "ลงทะเบียนจอดรถสำหรับผู้มาติดต่อหน้างาน",
      GetThaiID: "บัตรประชาชน",
      GetPassport: "หนังสือเดินทาง",
      PreRegisterDetail: "รายละเอียดการลงทะเบียน",
      CreateTime: "วันเวลาที่สร้าง",
      Approved: "ได้รับการอนุมัติ",
      NotApproved: "ไม่ได้รับการอนุมัติ",
      Active: "ใช้งาน",
      InActive: "ปิดใช้งาน",    
      Status: "สถานะ",
      Action: "จัดการ",
      VisitorType: "ประเภท",
      StatusApprove: "สถานะอนุมัติ",
      WalkInName: "ผู้มาติดต่อหน้างาน",
      JorporPlus: "จป. พลัส",
      SelfPreRegister: "ลงทะเบียนล่วงหน้าด้วยตัวเอง",
      Expired: "หมดอายุแล้ว",
      Rejected: "ถูกยกเลิก",
      UserManagement: "การจัดการบัญชีผู้ใช้",
      Username: "ชื่อบัญชี",
      RoleName: "สิทธิ์การใช้งาน",
      ManageUser: "จัดการบัญชีผู้ใช้",
      Password: "รหัสผ่าน",
      Role: "สิทธิ์การใช้งาน",
      SectionName: "แผนก",
      Update: "อัพเดท",
      ManageRole: "จัดการสิทธิ์การใช้งาน",
      RoleID: "รหัสสิทธิ์การใช้งาน",
      Permission: "สิทธิ์การใช้งาน",
      ManageSection: "การจัดการแผนก",
      BlackListVisitor: "การจัดการแบล็คลิสต์ผู้มาติดต่อ",
      SectionNameTH: "ชื่อแผนก",
      SectionNameENG: "ชื่อแผนกภาษาอังกฤษ",
      SectionID: "รหัสแผนก",
      Approver: "ผู้อนุมัติ",
      Subordinates: "ผู้ใช้งานที่อยู่ภายใต้การดูแล",
      Users: "ผู้ใช้งาน",
      ChangePassword: "เปลี่ยนรหัสผ่าน",
      OldPassword: "รหัสผ่านเดิม",
      NewPassword: "รหัสผ่านใหม่",
      ConfirmNewPassword: "ยืนยันรหัสผ่านใหม่",
      ChangePasswordRequired: "กรุณากรอกข้อมูลรหัสผ่านให้ครบถ้วน",
      ChangePasswordMismatch: "รหัสผ่านใหม่และการยืนยันรหัสผ่านต้องตรงกัน",
      ChangePasswordUpdated: "อัปเดตรหัสผ่านแล้ว",
      ChangePasswordSuccess: "อัปเดตรหัสผ่านสำเร็จ",
      ChangePasswordFailed: "ไม่สามารถเปลี่ยนรหัสผ่านได้",
      Logout: "ออกจากระบบ",
      BlackList: "แบล็คลิสต์ผู้มาติดต่อ",
      BlacklistID: "รหัสแบล็คลิสต์",
      InviteTenantName: "บริษัทที่มามาติดต่อ",
      InviteLocationName: "สถานที่ที่มาติดต่อ",
      GuestInviteName: "ชื่อผู้มาติดต่อ",
      InvitationName: "ชื่อผู้เชิญ",
      VisitorName: "ชื่อผู้มาติดต่อ",
      ViewPreRegister: "ดูข้อมูลการลงทะเบียนล่วงหน้า",
      GuestInformation: "ข้อมูลผู้มาติดต่อ",
      InviteNo: "หมายเลขเชิญ",
      InviteName: "ชื่อผู้มาติดต่อ",
      Location: "สถานที่ที่มาติดต่อ",
      Tenant: "บริษัท",
      VisitDuration: "ระยะเวลาที่มาติดต่อ",
      WantToReject: "ต้องการยกเลิกการลงทะเบียนนี้หรือไม่ ?",
      Reject: "ยกเลิก",
      Information: "ข้อมูล",
      RedemptionHistory: "ประวัติการประทับตราส่วนลด",
      BackToMain: "กลับสู่หน้าหลัก",
      SelectFloor: "เลือกชั้น",
      SyncMemberFineday: "เชื่อมกับสมาชิกบน Fineday",
      MemberID: "รหัสสมาชิก",
      Telephone: "เบอร์โทรศัพท์",
      RedemptionSettings: "ตั้งค่าการประทับตราส่วนลด",
      Department: "แผนก",
      RedemptionType: "ประเภทการประทับตรา",
      UserLevel: "ระดับผู้ใช้",
      UpdateTime: "วันเวลาที่อัพเดท",
      ParkingLot: "ทำรายการเข้าออกลานจอด",
      CreateInvite: "เพิ่มข้อมูลใหม่",
      InvitationEmail: "อีเมลล์ผู้เชิญ",
      SelectTenant: "เลือกบริษัทที่จะติดต่อ",
      InvitationUser: "จัดการผู้เชิญ",
      Name: "ชื่อ",
      TenantName: "ชื่อบริษัท",
      TenantNameTH: "ชื่อบริษัทภาษาไทย",
      ManageTenant: "จัดการบริษัท",
    },
    transactionRoomBooking: {
      filters: "ตัวกรองรายการจอง",
      startTime: "เวลาเริ่มต้น",
      expireTime: "เวลาสิ้นสุด",
      status: "สถานะ",
      search: "ค้นหา",
      searchTransaction: "ค้นหารายการจอง",
      export: "ส่งออก",
      swipeHint: "ปัดซ้ายหรือขวาเพื่อดูคอลัมน์ทั้งหมด",
      no: "ลำดับ",
      bookingName: "ชื่อการประชุม",
      hostName: "ชื่อผู้จอง",
      facility: "สถานที่",
      checkIn: "เช็คอิน",
      checkOut: "เช็คเอาต์",
      action: "การดำเนินการ",
      active: "ใช้งาน",
      inactive: "ไม่ใช้งาน",
      checkedIn: "เช็คอินแล้ว",
      notCheckedIn: "ยังไม่ได้เช็คอิน",
      checkedOut: "เช็คเอาต์แล้ว",
      notCheckedOut: "ยังไม่ได้เช็คเอาต์",
      editTransaction: "แก้ไขรายการจอง",
      deleteTransaction: "ลบรายการจอง",
      closeEditTransaction: "ปิดหน้าต่างแก้ไขรายการจอง",
      transactionStatus: "สถานะรายการจอง",
      noData: "ไม่พบข้อมูลรายการจอง",
      cancel: "ยกเลิก",
      save: "บันทึก",
      loading: "กำลังโหลด กรุณารอสักครู่...",
      connectionError: "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ",
      loadFailed: "ไม่สามารถโหลดรายการจองได้",
      facilityLoadFailed: "ไม่สามารถโหลดข้อมูลสถานที่ได้",
      exportFailed: "ไม่สามารถส่งออกรายการจองได้",
      error: "เกิดข้อผิดพลาด",
      invalidDateRange: "เวลาสิ้นสุดต้องเท่ากับหรือหลังเวลาเริ่มต้น",
      invalidTransactionId: "รหัสรายการจองไม่ถูกต้อง",
      updated: "อัปเดตแล้ว",
      updateSuccess: "อัปเดตข้อมูลสำเร็จ",
      updateFailed: "ไม่สามารถอัปเดตรายการจองได้",
      bookingNameRequired: "กรุณากรอกชื่อการประชุม",
      hostNameRequired: "กรุณากรอกชื่อผู้จอง",
      facilityRequired: "กรุณาเลือกสถานที่",
      startTimeRequired: "กรุณาเลือกเวลาเริ่มต้น",
      expireTimeRequired: "กรุณาเลือกเวลาสิ้นสุด",
      invalidDateTime: "เวลาเริ่มต้นหรือเวลาสิ้นสุดไม่ถูกต้อง",
      expireAfterStart: "เวลาสิ้นสุดต้องอยู่หลังเวลาเริ่มต้น",
      deleteConfirmTitle: "ลบรายการจอง?",
      deleteConfirmText: "คุณต้องการลบ {name} ใช่หรือไม่?",
      thisTransaction: "รายการจองนี้",
      delete: "ลบ",
      deleted: "ลบแล้ว",
      deleteSuccess: "ลบรายการจองสำเร็จ",
      deleteFailed: "ไม่สามารถลบรายการจองได้",
    },
    facilityPage: {
      title: "ห้องและสิ่งอำนวยความสะดวก",
      updatedAt: "อัปเดตล่าสุด",
      actions: "การดำเนินการ",
      search: "ค้นหา",
      searchFacility: "ค้นหาห้องและสิ่งอำนวยความสะดวก",
      create: "สร้าง",
      detail: "รายละเอียด",
      noUtilities: "ไม่มีอุปกรณ์อำนวยความสะดวก",
      delete: "ลบ",
      edit: "แก้ไข",
      noFacilities: "ไม่พบข้อมูลห้องและสิ่งอำนวยความสะดวก",
      createFacility: "สร้างห้องและสิ่งอำนวยความสะดวก",
      editFacility: "แก้ไขข้อมูลห้องและสิ่งอำนวยความสะดวก",
      close: "ปิด",
      facilityName: "ชื่อห้อง",
      roomType: "ประเภทห้อง",
      eventType: "ประเภทกิจกรรม",
      location: "โซน",
      floor: "ชั้น",
      startTime: "เวลาเริ่มต้น",
      endTime: "เวลาสิ้นสุด",
      room: "ห้อง",
      space: "พื้นที่",
      reserve: "จองล่วงหน้า",
      facilityPreview: "ตัวอย่างรูปภาพห้อง",
      changeImage: "เปลี่ยนรูปภาพห้อง",
      facilityStatus: "สถานะห้อง",
      active: "ใช้งาน",
      inactive: "ไม่ใช้งาน",
      no: "ลำดับ",
      utilityName: "ชื่ออุปกรณ์",
      amount: "จำนวน",
      deleteUtility: "ลบอุปกรณ์",
      noUtilityData: "ไม่พบข้อมูลอุปกรณ์",
      cancel: "ยกเลิก",
      save: "บันทึก",
      loading: "กำลังโหลด กรุณารอสักครู่...",
      error: "เกิดข้อผิดพลาด",
      utilityLoadFailed: "ไม่สามารถโหลดข้อมูลอุปกรณ์ได้",
      locationLoadFailed: "ไม่สามารถโหลดข้อมูลโซนได้",
      floorLoadFailed: "ไม่สามารถโหลดข้อมูลชั้นได้",
      loadFailed: "ไม่สามารถโหลดข้อมูลห้องได้",
      invalidImage: "รองรับเฉพาะไฟล์ PNG, JPG หรือ BMP ขนาดไม่เกิน 5 MB",
      imageReadFailed: "ไม่สามารถอ่านไฟล์รูปภาพได้",
      invalidImageFile: "ไฟล์รูปภาพไม่ถูกต้อง",
      facilityNameRequired: "กรุณากรอกชื่อห้อง",
      roomTypeRequired: "กรุณาเลือกประเภทห้อง",
      eventTypeRequired: "กรุณาเลือกประเภทกิจกรรม",
      locationRequired: "กรุณาเลือกโซน",
      floorRequired: "กรุณาเลือกชั้น",
      startTimeRequired: "กรุณาเลือกเวลาเริ่มต้น",
      endTimeRequired: "กรุณาเลือกเวลาสิ้นสุด",
      invalidTime: "เวลาเริ่มต้นหรือเวลาสิ้นสุดไม่ถูกต้อง",
      endAfterStart: "เวลาสิ้นสุดต้องอยู่หลังเวลาเริ่มต้น",
      saveFailed: "ไม่สามารถบันทึกข้อมูลห้องได้",
      created: "สร้างแล้ว",
      updated: "อัปเดตแล้ว",
      createSuccess: "สร้างข้อมูลสำเร็จ",
      updateSuccess: "อัปเดตข้อมูลสำเร็จ",
      deleteConfirmTitle: "ลบข้อมูลห้อง?",
      deleteConfirmText: "คุณต้องการลบข้อมูลห้องนี้ใช่หรือไม่?",
      deleteFailed: "ไม่สามารถลบข้อมูลห้องได้",
      deleted: "ลบแล้ว",
      deleteSuccess: "ลบข้อมูลสำเร็จ",
    },
    infrastructure: {
      search: "ค้นหา",
      status: "สถานะ",
      action: "การดำเนินการ",
      actions: "การดำเนินการ",
      create: "สร้าง",
      update: "อัปเดต",
      save: "บันทึก",
      cancel: "ยกเลิก",
      delete: "ลบ",
      close: "ปิด",
      active: "ใช้งาน",
      inactive: "ไม่ใช้งาน",
      loading: "กำลังโหลด กรุณารอสักครู่...",
      connectionError: "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ",
      created: "สร้างแล้ว",
      updated: "อัปเดตแล้ว",
      deleted: "ลบแล้ว",
      createSuccess: "สร้างข้อมูลสำเร็จ",
      updateSuccess: "อัปเดตข้อมูลสำเร็จ",
      deleteSuccess: "ลบข้อมูลสำเร็จ",
      editNamed: "แก้ไข {name}",
      deleteNamed: "ลบ {name}",
      zone: "โซน",
      utility: "อุปกรณ์",
      location: "สถานที่",
      zoneFilters: "ตัวกรองโซน",
      searchZone: "ค้นหาโซน",
      zoneName: "ชื่อโซน",
      zoneNameTH: "ชื่อโซนภาษาไทย",
      zoneStatus: "สถานะโซน",
      noZoneData: "ไม่พบข้อมูลโซน",
      editZone: "แก้ไขโซน",
      createZone: "สร้างโซน",
      closeZoneDialog: "ปิดหน้าต่างโซน",
      zoneNameRequired: "กรุณากรอกชื่อโซน",
      zoneNameTHRequired: "กรุณากรอกชื่อโซนภาษาไทย",
      zoneNameTooLong: "ชื่อโซนต้องไม่เกิน 200 ตัวอักษร",
      zoneNameTHTooLong: "ชื่อโซนภาษาไทยต้องไม่เกิน 200 ตัวอักษร",
      deleteZoneTitle: "ลบโซน?",
      deleteZoneText: "คุณต้องการลบโซนนี้ใช่หรือไม่?",
      searchUtility: "ค้นหาอุปกรณ์",
      utilityName: "ชื่ออุปกรณ์",
      utilityNameTH: "ชื่ออุปกรณ์ภาษาไทย",
      noUtilityData: "ไม่พบข้อมูลอุปกรณ์",
      editUtility: "แก้ไขอุปกรณ์",
      createUtility: "สร้างอุปกรณ์",
      utilityNameRequired: "กรุณากรอกชื่ออุปกรณ์",
      utilityNameTHRequired: "กรุณากรอกชื่ออุปกรณ์ภาษาไทย",
      utilityNameTooLong: "ชื่ออุปกรณ์ต้องไม่เกิน 200 ตัวอักษร",
      utilityNameTHTooLong: "ชื่ออุปกรณ์ภาษาไทยต้องไม่เกิน 200 ตัวอักษร",
      deleteUtilityTitle: "ลบอุปกรณ์?",
      deleteUtilityText: "คุณต้องการลบอุปกรณ์นี้ใช่หรือไม่?",
      locationFilters: "ตัวกรองสถานที่",
      searchLocation: "ค้นหาสถานที่",
      locationName: "ชื่อสถานที่",
      locationNameTH: "ชื่อสถานที่ภาษาไทย",
      locationStatus: "สถานะสถานที่",
      noLocationData: "ไม่พบข้อมูลสถานที่",
      editLocation: "แก้ไขสถานที่",
      createLocation: "สร้างสถานที่",
      closeLocationDialog: "ปิดหน้าต่างสถานที่",
      locationNameRequired: "กรุณากรอกชื่อสถานที่",
      locationNameTHRequired: "กรุณากรอกชื่อสถานที่ภาษาไทย",
      locationNameTooLong: "ชื่อสถานที่ต้องไม่เกิน 200 ตัวอักษร",
      locationNameTHTooLong: "ชื่อสถานที่ภาษาไทยต้องไม่เกิน 200 ตัวอักษร",
      deleteLocationTitle: "ลบสถานที่?",
      deleteLocationText: "คุณต้องการลบสถานที่นี้ใช่หรือไม่?",
    },
    management: {
      search: "ค้นหา", create: "สร้าง", update: "อัปเดต", cancel: "ยกเลิก",
      active: "ใช้งาน", inactive: "ไม่ใช้งาน", loading: "กำลังโหลด กรุณารอสักครู่...",
      confirm: "ยืนยัน", confirmInactive: "ยืนยันการปิดใช้งาน?", error: "เกิดข้อผิดพลาด",
      connectionError: "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ", saveFailed: "ไม่สามารถบันทึกข้อมูลได้", updateFailed: "ไม่สามารถอัปเดตข้อมูลได้",
      created: "สร้างแล้ว", updated: "อัปเดตแล้ว", createSuccess: "สร้างข้อมูลสำเร็จ", updateSuccess: "อัปเดตข้อมูลสำเร็จ",
      statusRequired: "กรุณาเลือกสถานะ", editNamed: "แก้ไข {name}", deleteNamed: "ลบ {name}",
      roomPadActions: "การดำเนินการ Room Pad", searchRoomPad: "ค้นหา Room Pad", roomPad: "Room Pad",
      padName: "ชื่อ Pad", facility: "ห้อง", noRoomPadData: "ไม่พบข้อมูล Room Pad",
      editRoomPad: "แก้ไข Room Pad", createRoomPad: "สร้าง Room Pad", deleteRoomPad: "ลบ Room Pad",
      closeRoomPadDialog: "ปิดหน้าต่าง Room Pad", generalInformation: "ข้อมูลทั่วไป", name: "ชื่อ",
      calendarType: "ประเภทปฏิทิน", systemConnection: "การเชื่อมต่อระบบ", calendarSyncHint: "ใช้สำหรับซิงค์ปฏิทิน",
      tenantId: "Tenant ID", clientId: "Client ID", clientSecret: "Client Secret", userEmail: "อีเมลผู้ใช้",
      googleCalendarId: "Google Calendar ID", roomPadStatus: "สถานะ Room Pad",
      roomPadNameRequired: "กรุณากรอกชื่อ Room Pad", facilityRequired: "กรุณาเลือกห้อง",
      calendarTypeRequired: "กรุณาเลือกประเภทปฏิทิน", tenantIdRequired: "กรุณากรอก Tenant ID",
      clientIdRequired: "กรุณากรอก Client ID", clientSecretRequired: "กรุณากรอก Client Secret",
      userEmailRequired: "กรุณากรอกอีเมลผู้ใช้", googleCalendarIdRequired: "กรุณากรอก Google Calendar ID",
      roomPadInactiveText: "Room Pad นี้จะถูกปิดใช้งาน",
      userActions: "การดำเนินการผู้ใช้", searchUser: "ค้นหาผู้ใช้", user: "ผู้ใช้", noUserData: "ไม่พบข้อมูลผู้ใช้",
      editUser: "แก้ไขผู้ใช้", createUser: "สร้างผู้ใช้", closeUserDialog: "ปิดหน้าต่างผู้ใช้",
      profileImage: "รูปโปรไฟล์", chooseProfileImage: "เลือกรูปโปรไฟล์", profilePreview: "ตัวอย่างรูปโปรไฟล์",
      removeImage: "ลบรูปภาพ", firstName: "ชื่อ", lastName: "นามสกุล", userName: "ชื่อผู้ใช้",
      password: "รหัสผ่าน", passwordEditHint: "เว้นว่างไว้หากไม่ต้องการเปลี่ยนรหัสผ่าน", email: "อีเมล", roleName: "ชื่อสิทธิ์",
      userStatus: "สถานะผู้ใช้", userInactiveText: "ผู้ใช้นี้จะถูกปิดใช้งาน",
      usernameRequired: "กรุณากรอกชื่อผู้ใช้", passwordRequired: "กรุณากรอกรหัสผ่าน",
      passwordMinLength: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร", firstNameRequired: "กรุณากรอกชื่อ",
      lastNameRequired: "กรุณากรอกนามสกุล", invalidEmail: "รูปแบบอีเมลไม่ถูกต้อง",
      roleRequired: "กรุณาเลือกสิทธิ์", roomPadRequired: "กรุณาเลือก Room Pad",
      shiftStartTime: "เวลาเริ่มกะ", shiftEndTime: "เวลาสิ้นสุดกะ", location: "สถานที่", serviceArea: "พื้นที่ให้บริการ",
      shiftHoursRequired: "กรุณาระบุเวลาเริ่มและสิ้นสุดกะในรูปแบบ HH:mm", shiftHoursDifferent: "เวลาเริ่มและสิ้นสุดกะต้องต่างกัน",
      locationRequired: "กรุณาเลือกสถานที่", serviceAreaRequired: "กรุณาเลือกพื้นที่ให้บริการของสถานที่นี้",
      invalidProfileImage: "รูปโปรไฟล์ต้องเป็นไฟล์ JPEG, PNG หรือ WebP",
      profileImageTooLarge: "รูปโปรไฟล์ต้องมีขนาดไม่เกิน 2 MB", profileImageReadFailed: "ไม่สามารถอ่านรูปโปรไฟล์ได้",
      roleTools: "เครื่องมือจัดการสิทธิ์", searchRole: "ค้นหาสิทธิ์", noRoleData: "ไม่พบข้อมูลสิทธิ์",
      editRole: "แก้ไขสิทธิ์", createRole: "สร้างสิทธิ์", deleteRole: "ลบสิทธิ์",
      closeRoleDialog: "ปิดหน้าต่างสิทธิ์", roleStatus: "สถานะสิทธิ์", permissionNamed: "สิทธิ์ {id}",
      roleNameRequired: "กรุณากรอกชื่อสิทธิ์", roleInactiveText: "สิทธิ์และ Permission ที่เกี่ยวข้องจะถูกปิดใช้งาน",
    },
    manageOrder: {
      title: "Manage Order", order: "Order", orderTime: "เวลาสั่ง", completedTime: "เวลาเสร็จสิ้น",
      status: "สถานะ", search: "ค้นหา", export: "Export", no: "ลำดับ", orderId: "Order ID",
      requester: "ผู้สั่ง", location: "สถานที่", zone: "โซน", staff: "พนักงาน", action: "รายละเอียด",
      new: "New", preparing: "กำลังเตรียม", ready: "Ready", completed: "Completed", rejected: "Rejected",
      details: "ดูรายละเอียด Order {id}", back: "กลับรายการ Order", information: "ข้อมูล Order",
      items: "รายการสินค้า", itemDescription: "สินค้าและตัวเลือก", quantity: "จำนวน",
      itemSummary: "{count} รายการ • รวม {quantity} ชิ้น", meeting: "ประชุม",
      service: "Service", serviceArea: "พื้นที่ให้บริการ", unassigned: "ยังไม่ระบุพนักงาน",
      cancelOrder: "ยกเลิก Order", cancelReason: "เหตุผลการยกเลิก", cancelHint: "ระบุเหตุผลไม่เกิน 500 ตัวอักษร",
      confirmCancel: "ยืนยันการยกเลิก", close: "ปิด", cancellationReason: "เหตุผลการยกเลิก",
      empty: "ไม่พบ Order", loading: "กำลังโหลด Order…", retry: "ลองอีกครั้ง",
      loadError: "ไม่สามารถโหลด Order ได้", detailError: "ไม่สามารถโหลดรายละเอียด Order ได้",
      accessError: "Role ของคุณไม่มีสิทธิ์จัดการ Order",
      cancelError: "ไม่สามารถยกเลิก Order ได้", conflict: "Order นี้มีการเปลี่ยนแปลง ระบบโหลดข้อมูลล่าสุดแล้ว กรุณาตรวจสอบก่อนดำเนินการอีกครั้ง",
      exportError: "ไม่สามารถ Export Order ได้", rowsPerPage: "จำนวนรายการต่อหน้า", filters: "ตัวกรอง Order",
      unknown: "ไม่ทราบสถานะ", clearDate: "ล้างวันที่", units: "ชิ้น", exportItems: "รายการสินค้า",
    },
    dashboard: {
      title: "ภาพรวมพื้นที่ทำงาน", updatedAt: "อัปเดตล่าสุด", refresh: "รีเฟรช", logout: "ออกจากระบบ",
      transaction: "รายการจอง", facility: "ห้องและสิ่งอำนวยความสะดวก", zone: "โซน", utility: "อุปกรณ์", location: "สถานที่", roomPad: "Room Pad", manageUser: "จัดการผู้ใช้", manageRole: "จัดการสิทธิ์",
      allRoom: "ห้องทั้งหมด", meetingNow: "กำลังประชุม", available: "ว่าง", bookingToday: "การจองวันนี้", pendingOrder: "Order ที่รอดำเนินการ",
      floorMap: "แผนผังชั้น", selectFloor: "เลือกชั้น", allFloors: "ทุกชั้น", nextMeeting: "ประชุมถัดไป", noNextMeeting: "ไม่มีการประชุมถัดไป", viewSchedule: "ดูตารางห้อง",
      activity: "กิจกรรม", latestOrder: "Order ล่าสุด", noRooms: "ไม่พบห้องในชั้นนี้", noActivity: "ไม่มีกิจกรรมล่าสุด", noOrders: "ไม่มี Order ล่าสุด",
      loadError: "ไม่สามารถโหลดข้อมูล Dashboard ได้", retry: "ลองอีกครั้ง", loading: "กำลังโหลด Dashboard", sent: "ส่งแล้ว", new: "ใหม่",
      booking: "สร้างการจอง", checkin: "Check-in สำเร็จ", checkout: "Check-out สำเร็จ", updated: "แก้ไขการจอง", hostedBy: "ผู้จอง",
    },
  },
};
const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages,
});

Vue.filter("myLocale", function (value) {
  return i18n.t(value);
});

export default i18n;
